import React, { useEffect, useRef, useState } from 'react';
import {
  Autocomplete,
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';
import Iconify from '../iconify';
import {
  EditUserDetails,
  GetBranches,
  GetDepartments,
  GetLogedInUser,
  GetRoles,
  GetUser,
  GetUserCompanies,
  PostUser,
} from '../services/httpServices';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

export default function ChangePassword(props) {
  let { id } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState({});
  const [roles, setRoles] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [saved, setSaved] = useState(false);
  const [passwordButton, setPasswordButton] = useState(true);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [vertical, setVertical] = useState('bottom');
  const [horizontal, setHorizontal] = useState('right');
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [message, setMessage] = useState('');
  const [isActive, setIsActive] = useState(true);
  const [userCompanies, setUserCompanies] = useState([]);
  const nameRef = useRef('');
  const userNameRef = useRef('');
  const passwordRef = useRef('');
  const userEmailRef = useRef('');
  const userRoleRef = useRef('');

  const fetchUser = async () => {
    var response = await GetLogedInUser();
    const companies = await GetUserCompanies();
    const savedBranches = await GetBranches();

    if (response !== null) {
      setUser(response);
      let userRole = roles.find((e) => e.key == user.userRoleId);
      let userDepartment = departments.find((e) => e.key == user.deptId);

      let branch = savedBranches.find((e) => e.prcCode == response.branchCode);
      let company = companies.find((e) => e.id == response.userCompanyId);
      setUserCompanies(companies);
      setBranches(savedBranches);
      console.log(companies, savedBranches);
      setSelectedBranch(branch);
      setSelectedCompany(company);
      setSelectedRole(userRole);
      setSelectedDepartment(userDepartment);
      setIsActive(response.isActive);

      //console.log('selectedRole:', selectedRole);
      setLoading(false);
    }
  };
  const fetchRoles = async (event) => {
    const roles = await GetRoles();
    const departments = await GetDepartments();

    setRoles(roles);
    setDepartments(departments);
    //console.log('Roles:', roles);
    fetchUser();
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  const SaveUser = async (event) => {
    event.preventDefault();
    // console.log('editHit');
    const payload = {
      id: user.id,
      name: nameRef.current.value,
      username: userNameRef.current.value,
      password: passwordRef.current.value,
      userEmail: userEmailRef.current.value,
      userRoleId: selectedRole ? selectedRole.key : user.userRoleId.toString(),
      deptId: selectedDepartment ? selectedDepartment.key : user.deptId.toString(),
      isActive: isActive,
      branchCode: selectedBranch?.prcCode,
      branchName: selectedBranch?.prcName,
      userCompanyId: selectedCompany?.id,
    };

    console.log(payload);
    let response = await EditUserDetails(payload);
    //  console.log('PostResponse:', response);
    if (response.status == 200) {
      setMessage(response.data);
      setSaved(true);
      setOpen(true);
      setTimeout(() => {
        localStorage.clear();
        localStorage.removeItem('Item');
        setOpen(null);
        navigate('/login');
      }, 3000);
    } else {
      setMessage(response.data);
      setSaved(false);
      setOpen(true);
      // setPosting(false);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleChangeActive = (event) => {
    setIsActive(event.target.value);
  };
  const PasswordCheck = (event) => {
    event.preventDefault();
    passwordRef.current.value != user.password ? setPasswordButton(false) : setPasswordButton(true);
  };
  return (
    <>
      <Helmet>
        <title> Change Password | Immigration System </title>
      </Helmet>

      <Container>
        <form onSubmit={SaveUser}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              Change Password
            </Typography>
            {/* <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}> */}

            <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2}>
              <Button
                onClick={() => {
                  navigate(-1);
                }}
                variant="contained"
              >
                Back
              </Button>
              <Button disabled={passwordButton} type="submit" variant="contained">
                Save
              </Button>
            </Stack>
          </Stack>
          {loading ? (
            <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
              <CircularProgress size={60} thickness={3} value={100} />
            </Grid>
          ) : (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Box component={Paper} p={4}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        disabled
                        label="Name"
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        defaultValue={user.name}
                        inputRef={nameRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        disabled
                        label="Username"
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        defaultValue={user.userName}
                        inputRef={userNameRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Password"
                        required
                        type="password"
                        variant="outlined"
                        fullWidth
                        size="small"
                        defaultValue={user.password}
                        onChange={PasswordCheck}
                        inputRef={passwordRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        disabled
                        label="Email"
                        variant="outlined"
                        fullWidth
                        size="small"
                        defaultValue={user.userEmail}
                        inputRef={userEmailRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3} hidden>
                      <Autocomplete
                        disabled
                        id="role"
                        size="small"
                        options={roles}
                        defaultValue={roles.find((e) => e.key == user.userRoleId)}
                        getOptionLabel={(role) => role.value}
                        renderInput={(params) => (
                          <TextField
                            required
                            {...params}
                            // defaultValue={selectedRole}
                            inputRef={userRoleRef}
                            label="Role"
                            variant="outlined"
                          />
                        )}
                        onChange={(event, role) => setSelectedRole(role)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3} hidden>
                      <Autocomplete
                        disabled
                        id="department"
                        size="small"
                        options={departments}
                        defaultValue={departments.find((e) => e.key == user.deptId)}
                        getOptionLabel={(department) => department.value}
                        renderInput={(params) => (
                          <TextField required {...params} label="Department" variant="outlined" />
                        )}
                        onChange={(event, department) => setSelectedDepartment(department)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3} hidden>
                      <FormControl>
                        <RadioGroup
                          aria-labelledby="demo-controlled-radio-buttons-group"
                          name="controlled-radio-buttons-group"
                          value={isActive}
                          onChange={handleChangeActive}
                          row
                        >
                          <FormControlLabel value={true} control={<Radio />} label="Active" />
                          <FormControlLabel value={false} control={<Radio />} label="In Active" />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          )}
        </form>
        {saved ? (
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            key={vertical + horizontal}
            open={open}
            autoHideDuration={4000}
            onClose={handleClose}
          >
            <Alert elevation={6} variant="filled" onClose={handleClose} severity="success">
              {message}
            </Alert>
          </Snackbar>
        ) : (
          <Snackbar
            key={vertical + horizontal}
            anchorOrigin={{ vertical, horizontal }}
            open={open}
            autoHideDuration={4000}
            onClose={handleClose}
          >
            <Alert elevation={6} variant="filled" onClose={handleClose} severity="error">
              {message}
            </Alert>
          </Snackbar>
        )}
      </Container>
    </>
  );
}
